import React from 'react'

const Reports = () => {
  return (
    <div>reports</div>
  )
}

export default Reports